import { desc, link } from "framer-motion/client";
import { Link } from "react-router";

export const Projects = [
  {
    name: "Cysic",
    logo: "/images/cysiclogo.jpg",
    desc: "Hardware-accelerated ZK proof generation built for speed and scalability.",
    twitter: "https://x.com/cysic_xyz",
    discord: "https://discord.gg/cysic",
    link: "/cysic",
    status: "Ongoing",
    type: "ZK / Infrastructure", // added
  },
  {
    name: "Allora",
    logo: "/images/allora.jpg",
    desc: "Decentralized prediction layer connecting machine intelligence to on-chain data.",
    twitter: "https://x.com/alloranetwork",
    discord: "https://discord.gg/allora",
    link: "/allora",
    status: "Completed",
    type: "Prediction / AI", // added
  },
  {
    name: "Monad",
    logo: "/images/monad.jpg",
    desc: "A high-performance Layer 1 EVM chain focused on parallel execution.",
    twitter: "https://x.com/monad_xyz",
    discord: "https://discord.gg/monad",
    status: "Completed",
    type: "Layer 1", // added
  },
  {
    name: "Sentient",
    logo: "/images/sentilogo.jpg",
    desc: "Open AGI platform where intelligence is decentralized, not owned.",
    twitter: "https://x.com/SentientAGI",
    discord: "https://discord.gg/sentientfoundation",
    link: "/sentient",
    status: "Ongoing",
    type: "AI / AGI", // added
  },
  {
    name: "Fogo",
    logo: "/images/fogo.jpg",
    desc: "A high-performance SVM Layer 1 built for trading, liquidity, and speed — blending exchange-grade efficiency with decentralized trust.",
    twitter: "https://x.com/FogoChain",
    discord: "https://discord.gg/fogochain",
    link: "/fogo",
    status: "Completed",
    type: "Layer 1 / DeFi", // added
  },
  {
    name: "Ritual",
    logo: "/images/ritual.jpg",
    desc: "A decentralized compute protocol for AI inference and model deployment.",
    discord: "https://discord.gg/bJYTRdNM",
    twitter: "https://x.com/ritualnet",
    link: "/ritual",
    status: "Ongoing",
    type: "AI / Infrastructure", // added
  },
  {
    name: "Dango",
    logo: "/images/dango/dango.jpg",
    desc: "A web3-native social network where creators and communities thrive together.",
    discord: "https://discord.gg/bJYTRdNM",
    twitter: "https://x.com/dango",
    link: "/dango",
    status: "Ongoing",
    type: "Social / Web3", // added
  },
  {
    name: "Rialo",
    logo: "/images/riaol/riaol.jpg",
    desc: "A gamified claim portal and project hub for crypto explorers.",
    discord: "https://discord.gg/5P5CKHFz",
    twitter: "https://x.com/RialoHQ",
    link: "/rialo",
    status: "Ongoing",
    type: "Community / GameFi", // added
  },
   {
    name: "miden",
    logo: "/images/miden/midenwallp.png",
    desc: "A gamified claim portal and project hub for crypto explorers.",
    twitter: "https://x.com/0xMiden",
    link: "/miden",
    status: "Ongoing",
    type: "Community , ZK , privacy , open source",
  },
];
